export const registerLottieAPI = () => {
  try {
    window.__FT_PROJECT__LOTTIE__API__ = window.__FT_PROJECT__LOTTIE__API__ || {}
    window.__FT_PROJECT__LOTTIE__API__.callbackCache = {}
    window.__FT_PROJECT__LOTTIE__API__.isLoaded = function (assetID) {
      return Boolean(window.__FT__LOTTIE_CACHE__ && window.__FT__LOTTIE_CACHE__[assetID])
    }
    window.__FT_PROJECT__LOTTIE__API__.addLoadCallback = function (assetID, loadID, callback) {
      if (window.__FT_PROJECT__LOTTIE__API__.isLoaded(assetID)) {
        return callback()
      }
      window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID] =
        window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID] || {}
      window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID][loadID] = callback
    }
    window.__FT_PROJECT__LOTTIE__API__.processLoadAsset = function (assetID) {
      // if (process.env.NODE_ENV === 'development') {
      // console.log('Lottie asset %s loaded.', assetID)
      // }
      var callbacks = window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID] || {}
      var keys = Object.keys(callbacks)
      for (var i = 0; i < keys.length; i++) {
        if (typeof callbacks[keys[i]] === 'function') {
          callbacks[keys[i]]()
        }
        delete window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID][keys[i]]
      }
      window.__FT_PROJECT__LOTTIE__API__.callbackCache[assetID] = {}
    }
  } catch (error) {
    console.error(error)
  }
}
